import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import React, { useState } from 'react';
import { ProjectCard } from "./ProjectCard";

import thumbnail1 from "../assets/img/thumbnails/Funbay Poster.jpg";
import thumbnail2 from "../assets/img/thumbnails/Foodiv Poster.jpg";
import thumbnail3 from "../assets/img/thumbnails/Quizard Poster.jpg";
import thumbnail4 from "../assets/img/thumbnails/RN Academy Poster.jpg";
import thumbnail5 from "../assets/img/thumbnails/Echo Poster.jpg";
import thumbnail6 from "../assets/img/thumbnails/Planto Poster.jpg";
import thumbnail7 from "../assets/img/thumbnails/Pastie Poster.jpg";
import thumbnail11 from "../assets/img/thumbnails/Livein Tenant Poster.jpg";
import thumbnail12 from "../assets/img/thumbnails/PS Healthcare Poster.jpg";
import thumbnail55 from "../assets/img/thumbnails/Happy Pet Poster.jpg";
import thumbnail33 from "../assets/img/thumbnails/Uguardian Poster.jpg";
import thumbnail100 from "../assets/img/thumbnails/Wflow Monitor Poster.jpg";
import thumbnail102 from "../assets/img/thumbnails/Reporite-Poster.jpg";

import personal_thumbnail1 from "../assets/img/thumbnails/Skywatch.jpg";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {
  const projects = [
    {
      id: 11,
      title: "Livein Tenant",
      description: "Society management App",
      imgUrl: thumbnail11,
    },
    {
      id: 10,
      title: "PS Healthcare",
      description: "Healthcare App",
      imgUrl: thumbnail12,
    },
    {
      id: 9,
      title: "Funbay",
      description: "Entertainment App",
      imgUrl: thumbnail1,
    },
    {
      id: 8,
      title: "Quizard",
      description: "Educational App",
      imgUrl: thumbnail3,
    },
    {
      id: 7,
      title: "Uguardian",
      description: "SOS App",
      imgUrl: thumbnail33,
    },
    {
      id: 6,
      title: "Foodiv",
      description: "Food Delivery App",
      imgUrl: thumbnail2,
    },
    {
      id: 5,
      title: "RNN Academy",
      description: "Educational App",
      imgUrl: thumbnail4,
    },
    {
      id: 4,
      title: "Echo",
      description: "E-commerce App",
      imgUrl: thumbnail5,
    },
    {
      id: 3,
      title: "Happy Pet",
      description: "Petcare App",
      imgUrl: thumbnail55,
    },
    {
      id: 2,
      title: "Planto",
      description: "Health ML App",
      imgUrl: thumbnail6,
    },
    {
      id: 1,
      title: "Pastie",
      description: "Utility App",
      imgUrl: thumbnail7,
    },
  ];

  const personal_projects = [
    {
      id: 102,
      title: "Reporite",
      description: "Document Generation App",
      imgUrl: thumbnail102,
    },
    {
      id: 101,
      title: "SkyWatch",
      description: "Weather App",
      imgUrl: personal_thumbnail1,
    },
    {
      id: 100,
      title: "Wflow Monitor",
      description: "Automated water control app",
      imgUrl: thumbnail100,
    }
  ];

  // Add state for visible projects
  const [visibleProjects, setVisibleProjects] = useState(6);
  const [activeProject, setActiveProject] = React.useState(null);

  const handleProjectClick = (project) => {
    setActiveProject(project.id);
  };

  // Handle view more button
  const handleViewMore = () => {
    setVisibleProjects(projects.length);
  };

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div>
                  <h2>Projects</h2>
                  <p>I'm proud to share some of the projects that I've have created. Explore them and see what I can do.</p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                      <Nav.Item>
                        <Nav.Link eventKey="first">Professional Projects</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Personal Projects</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content id="slideInUp">
                      <Tab.Pane eventKey="first">
                        <Row>
                          {
                            projects.slice(0, visibleProjects).map((project, index) => {
                              return (
                                <ProjectCard
                                  key={index}
                                  {...project}
                                />
                              )
                            })
                          }
                        </Row>

                        {/* View More button only if there are more projects to show */}
                        {visibleProjects < projects.length && (
                          <div className="mt-5 d-flex justify-content-center">
                            <Nav.Item style={{ width: "fit-content" }}>
                              <button
                                onClick={handleViewMore}
                                style={{
                                  background: "rgba(255, 255, 255, 0.9)",
                                  color: "black",
                                  border: "1px solid rgba(255, 255, 255, 0.1)",
                                  padding: "12px 30px",
                                  borderRadius: "30px",
                                  fontSize: "16px",
                                  fontWeight: "500",
                                  cursor: "pointer",
                                  width: "100%",
                                  minWidth: "400px"
                                }}
                              >
                                View More
                              </button>
                            </Nav.Item>
                          </div>
                        )}
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <Row>
                          {
                            personal_projects.map((project, index) => {
                              return (
                                <ProjectCard
                                  key={index}
                                  {...project}
                                />
                              )
                            })
                          }
                        </Row>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
